<template>
    <div class="w-full h-auto relative overflow-hidden">
        <img src="../../assets/img/Mobile/back3.webp" alt="" class="w-full h-auto">
        <div class="absolute top-[8vw] right-[2.5vw] w-[95vw] flex flex-col">
            <p class="text-[12vw] font-emeritus text-white text-end uppercase leading-[12vw]">
                DEEP<br />
                Strategy<br />
                Effortless<br />
                Progress
            </p>
            <p class="text-[3.25vw] font-league text-white font-normal text-end mt-[2vw]">
                Freely arrange your team, activate skills, and watch your army auto-<br />battle and gather
                resources—even while you're offline.
            </p>
            <div class="container-anh relative w-[95vw] mt-[4vw]">
                <img src="../../assets/img/Desktop/DeepStrategy/4.webp" alt="" class="absolute top-0 left-0 w-[68vw]">
                <div class="absolute top-[40vw] w-[95vw] flex flex-col items-center">
                    <img src="../../assets/img/Desktop/DeepStrategy/5.webp" alt="" class="w-[65vw]">
                    <img src="../../assets/img/Mobile/Frame 108.webp" alt="" class="w-[95vw]">
                    <img src="../../assets/img/Desktop/DeepStrategy/6.webp" alt="" class="w-[65vw] z-20">
                    <div class="w-full flex flex-row px-[29vw] justify-between translate-y-[-3vw] z-10">
                        <img src="../../assets/img/Desktop/DeepStrategy/Object 2.webp" alt="" class="w-[5.5vw] h-auto">
                        <img src="../../assets/img/Desktop/DeepStrategy/Object 2.webp" alt="" class="w-[5.5vw] h-auto">
                    </div>
                </div>
            </div>
            <img src="../../assets/img/Desktop/DeepStrategy/3.webp" alt=""
                class="absolute top-[197vw] w-[95.3vw] left-[25vw] z-30">
        </div>

        <!-- Container blur -->
        <div
            class="absolute top-[270vw] w-full h-[220vw] bg-[#00000010] backdrop-blur-ip backdrop-blur-[3vw] z-20 flex flex-col items-end">
            <p class="text-[12vw] font-emeritus text-end text-gradient-summon pr-[2.5vw] pt-[16vw]">SUMMON</p>
            <p class="text-[8.0vw] w-[95vw] pr-[2.5vw] font-emeritus text-end text-gradient-inner uppercase">Legendary
                Heroes</p>
            <div class="w-[95vw] pr-[2.5vw] relative h-[4vw] flex flex-row justify-between items-center mt-[4vw]">
                <div class="w-[2vw] h-[2vw] rotate-[45deg] bg-white"></div>
                <div class="w-[95vw] h-[0.6vw] bg-white"></div>
                <div class="w-[2vw] h-[2vw] rotate-[45deg] bg-white"></div>
            </div>
            <p class="text-white text-[3.25vw] text-end font-league pr-[2.5vw] mt-[4vw]">
                Hundreds of unique heroes, each with their own skills and traits.
                <br />
                Collect, upgrade, and create your unstoppable army
            </p>

            <div class="w-[95vw] h-[117vw]  mt-[5vw] mr-[2.5vw] relative overflow-hidden flex">
                <img src="../../assets/img/Mobile/Backzz.webp" alt="" class="w-[95vw] h-auto">
                <div class="w-full flex flex-row absolute top-[12vw] content-inner space-x-[5vw] pl-[20vw] pr-[20vw]">
                    <!-- items 1 -->
                    <div class="items-to-hover relative flex justify-center w-[56.7vw]">
                        <img src="../../assets/img/Desktop/SummonLegendaryHeroes/2.webp" alt="" class="w-[56.7vw]">
                        <!-- content -->
                        <div class="absolute top-[60vw] w-[52vw] flex flex-col">
                            <p class="text-[5.9vw] text-white font-emeritus [text-shadow:0.1vw_0.1vw_#00000025]">
                                Morgan Magic</p>
                            <div class="flex flex-row justify-between">
                                <!-- 1 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/10.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">560</p>
                                        <p class="text-[2.5vw] font-league text-white">Health</p>
                                    </div>
                                </div>
                                <div class="w-[0.1vw] h-[7vw] bg-white translate-y-[1vw]"></div>
                                <!-- 2 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/9.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">70</p>
                                        <p class="text-[2.5vw] font-league text-white">Attack</p>
                                    </div>
                                </div>
                                <div class="w-[0.1vw] h-[7vw] bg-white translate-y-[1vw]"></div>
                                <!-- 3 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/1.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">10</p>
                                        <p class="text-[2.5vw] font-league text-white">Amor</p>
                                    </div>
                                </div>
                            </div>
                            <!-- button -->
                            <div class="w-[52vw] h-[7.5vw] flex justify-center mt-[2.5vw]">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/SummonNow.webp" alt=""
                                    class="h-[7.5vw] hover:cursor-pointer" @click="openWebLink('https://play.idle-glory.io/')">
                            </div>
                        </div>
                    </div>
                    <!-- items 2 -->
                    <div class="items-to-hover relative flex justify-center w-[56.7vw]">
                        <img src="../../assets/img/Desktop/SummonLegendaryHeroes/3.webp" alt="" class="w-[56.7vw]">
                        <!-- content -->
                        <div class="absolute top-[60vw] w-[52vw] flex flex-col">
                            <p class="text-[5.9vw] text-white font-emeritus [text-shadow:0.1vw_0.1vw_#00000025]">
                                Doomhowl</p>
                            <div class="flex flex-row justify-between">
                                <!-- 1 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/10.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">680</p>
                                        <p class="text-[2.5vw] font-league text-white">Health</p>
                                    </div>
                                </div>
                                <div class="w-[0.1vw] h-[7vw] bg-white translate-y-[1vw]"></div>
                                <!-- 2 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/9.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">78</p>
                                        <p class="text-[2.5vw] font-league text-white">Attack</p>
                                    </div>
                                </div>
                                <div class="w-[0.1vw] h-[7vw] bg-white translate-y-[1vw]"></div>
                                <!-- 3 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/1.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">16</p>
                                        <p class="text-[2.5vw] font-league text-white">Amor</p>
                                    </div>
                                </div>
                            </div>
                            <!-- button -->
                            <div class="w-[52vw] h-[7.5vw] flex justify-center mt-[2.5vw]">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/SummonNow.webp" alt=""
                                    class="h-[7.5vw] hover:cursor-pointer" @click="openWebLink('https://play.idle-glory.io/')">
                            </div>
                        </div>
                    </div>
                    <!-- items 3 -->
                    <div class="items-to-hover relative flex justify-center w-[56.7vw]">
                        <img src="../../assets/img/Desktop/SummonLegendaryHeroes/4.webp" alt="" class="w-[56.7vw]">
                        <!-- content -->
                        <div class="absolute top-[60vw] w-[52vw] flex flex-col">
                            <p class="text-[5.9vw] text-white font-emeritus [text-shadow:0.1vw_0.1vw_#00000025]">
                                Elezar Icecaller</p>
                            <div class="flex flex-row justify-between">
                                <!-- 1 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/10.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">620</p>
                                        <p class="text-[2.5vw] font-league text-white">Health</p>
                                    </div>
                                </div>
                                <div class="w-[0.1vw] h-[7vw] bg-white translate-y-[1vw]"></div>
                                <!-- 2 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/9.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">66</p>
                                        <p class="text-[2.5vw] font-league text-white">Attack</p>
                                    </div>
                                </div>
                                <div class="w-[0.1vw] h-[7vw] bg-white translate-y-[1vw]"></div>
                                <!-- 3 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/1.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">13</p>
                                        <p class="text-[2.5vw] font-league text-white">Amor</p>
                                    </div>
                                </div>
                            </div>
                            <!-- button -->
                            <div class="w-[52vw] h-[7.5vw] flex justify-center mt-[2.5vw]">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/SummonNow.webp" alt=""
                                    class="h-[7.5vw] hover:cursor-pointer" @click="openWebLink('https://play.idle-glory.io/')">
                            </div>
                        </div>
                    </div>
                    <!-- items 4 -->
                    <div class="items-to-hover relative flex justify-center w-[56.7vw]">
                        <img src="../../assets/img/Desktop/SummonLegendaryHeroes/5.webp" alt="" class="w-[56.7vw]">
                        <!-- content -->
                        <div class="absolute top-[60vw] w-[52vw] flex flex-col">
                            <p class="text-[5.6vw] text-white font-emeritus [text-shadow:0.1vw_0.1vw_#00000025]">
                                Molok Steelhorn</p>
                            <div class="flex flex-row justify-between">
                                <!-- 1 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/10.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">700</p>
                                        <p class="text-[2.5vw] font-league text-white">Health</p>
                                    </div>
                                </div>
                                <div class="w-[0.1vw] h-[7vw] bg-white translate-y-[1vw]"></div>
                                <!-- 2 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/9.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">80</p>
                                        <p class="text-[2.5vw] font-league text-white">Attack</p>
                                    </div>
                                </div>
                                <div class="w-[0.1vw] h-[7vw] bg-white translate-y-[1vw]"></div>
                                <!-- 3 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/1.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">14</p>
                                        <p class="text-[2.5vw] font-league text-white">Amor</p>
                                    </div>
                                </div>
                            </div>
                            <!-- button -->
                            <div class="w-[52vw] h-[7.5vw] flex justify-center mt-[2.5vw]">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/SummonNow.webp" alt=""
                                    class="h-[7.5vw] hover:cursor-pointer" @click="openWebLink('https://play.idle-glory.io/')">
                            </div>
                        </div>
                    </div>
                    <!-- items 5 -->
                    <div class="items-to-hover relative flex justify-center w-[56.7vw]">
                        <img src="../../assets/img/Desktop/SummonLegendaryHeroes/6.webp" alt="" class="w-[56.7vw]">
                        <!-- content -->
                        <div class="absolute top-[60vw] w-[52vw] flex flex-col">
                            <p class="text-[5.9vw] text-white font-emeritus [text-shadow:0.1vw_0.1vw_#00000025]">
                                Baron Goldchest</p>
                            <div class="flex flex-row justify-between">
                                <!-- 1 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/10.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">590</p>
                                        <p class="text-[2.5vw] font-league text-white">Health</p>
                                    </div>
                                </div>
                                <div class="w-[0.1vw] h-[7vw] bg-white translate-y-[1vw]"></div>
                                <!-- 2 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/9.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">75</p>
                                        <p class="text-[2.5vw] font-league text-white">Attack</p>
                                    </div>
                                </div>
                                <div class="w-[0.1vw] h-[7vw] bg-white translate-y-[1vw]"></div>
                                <!-- 3 -->
                                <div class="flex flex-row items-center">
                                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/1.webp" alt=""
                                        class="w-[6vw] h-[5.2vw]">
                                    <div class="flex flex-col justify-between pl-[1vw]">
                                        <p class="text-[4.5vw] font-emeritus text-white">11</p>
                                        <p class="text-[2.5vw] font-league text-white">Amor</p>
                                    </div>
                                </div>
                            </div>
                            <!-- button -->
                            <div class="w-[52vw] h-[7.5vw] flex justify-center mt-[2.5vw]">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/SummonNow.webp" alt=""
                                    class="h-[7.5vw] hover:cursor-pointer" @click="openWebLink('https://play.idle-glory.io/')">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
function openWebLink(url) {
  setTimeout(() => {
    window.open(url, "_blank");
  }, 300);
}
</script>

<style scoped>
.font-emeritus {
    font-family: "Emeritus", sans-serif;
}

.font-league {
    font-family: "LeagueSpartan", sans-serif;
}

.text-gradient-summon {
    background: linear-gradient(to top right,
            #C5EEFF 0%,
            #E8E8E8 50%,
            #F4FF8D 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.text-gradient-inner {
    background: linear-gradient(to top,
            #FEE7EB 0%,
            #FEF9D8 80%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.content-inner {
    display: flex;
    overflow-x: scroll;
    scroll-behavior: smooth;
    padding-left: 20vw;
    padding-right: 20vw;
    padding-left: 20vw;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.content-inner::-webkit-scrollbar {
    display: none;
}

.items-to-hover {
    flex-shrink: 0;
    scroll-snap-align: center;
}

.content-inner {
    scroll-snap-type: x mandatory;
}

.backdrop-blur-ip{
    backdrop-filter: blur(3vw);
    -webkit-backdrop-filter: blur(3vw);
}
</style>